import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'input',
    'field'
  ];

  initialize () {
    this.placeChanged = this.placeChanged.bind(this);
  }

  connect () {
    // TODO : update with new autocomplete place google API
    if (typeof window.google !== 'undefined') {
      this.initAutocomplete();
    }
  }

  initAutocomplete () {
    this.autocomplete = new window.google.maps.places.Autocomplete(this.inputTarget, {});
    this.autocomplete.addListener('place_changed', this.placeChanged);
  }

  placeChanged () {
    this.place = this.autocomplete.getPlace();

    const addressComponents = this.place.address_components;

    if (addressComponents) {
      const formattedAddress = this.formatAddress(addressComponents);

      this.fieldTargets.forEach((target) => {
        const type = target.dataset.addressAutocompleteType;

        let value;
        if (type === 'route') {
          const streetNumber = formattedAddress['street_number'] || '';
          const streetName = formattedAddress['route'] || '';
          value = streetNumber ? `${streetNumber} ${streetName}`.trim() : streetName;
        } else {
          value = formattedAddress[type] || '';
        }

        if (target.tomselect) {
          target.tomselect.setValue(value);
        } else {
          target.value = value;
        }
      });
    }
  }

  preventSubmit (event) {
    if (event.code === 'Enter') {
      event.preventDefault();
    }
  }

  formatAddress (addressComponents) {
    const formatted = {};

    addressComponents.forEach((component) => {
      const type = component.types[0];

      if (type === 'country') {
        formatted[type] = component.short_name;
      } else {
        formatted[type] = component.long_name;
      }
    });

    return formatted;
  }
}
